import { useState, useEffect, useRef } from "react";
import GetIcon from "../../../../utils/Icon";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Pagination from "../../../../Components/Pagination";
import ConfigureColumns from "../Create-Purchase-Receipt/ConfigureColumns";
import EditItemModal from "./EditItemModal";
import useKeyboardNavigation from "../../../../utils/useKeyboardNavigation";

const Table = ({ list_data, row, fulldata,status }) => {
  const tableRef = useRef(null);
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error");
  const [full_Item_Detail, setfull_Item_Detail] = useState({});
  const [showError, setShowError] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [columeConfModal, setcolumeConfModal] = useState(false);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const { focusedCellkey, setFocusedCellkey } = useKeyboardNavigation(row.Rows.length);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);

  const [visibleColumns, setVisibleColumns] = useState([
    { name: "S.No", selected: true, key: "sno", width: "4%" },
    { name: "Item Code", selected: true, key: "item_code", width: "17%" },
    { name: "Item Name", selected: true, key: "item_name", width: "25%" },
    { name: " Qty", selected: true, key: "qty", width: "4%" },
    { name: "Accepted Qty", selected: true, key: "accepted_qty", width: "9%" },
    { name: "UOM", selected: true, key: "uom", width: "5%" },
    { name: "Rate", selected: true, key: "rate", width: "10%" },
    { name: "Amount", selected: true, key: "amount", width: "10%" },
    { name: "Reject Qty", selected: false, key: "rejected_qty", width: "6%" },
    { name: "Barcode", selected: false, key: "barcode", width: "6%" },
    // { name: "Manufacturing Date", selected: false, key: "manufacturing_date", width: "80px" },
    { name: "Batch No.", selected: false, key: "batch_no", width: "6%" },
    { name: "Serial No.", selected: false, key: "serial_numbers", width: "6%" },
    { name: "Expiry Date", selected: false, key: "expiry_date", width: "6%" },
    { name: "Settings", selected: true, key: "settings", width: "4%" }
  ]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = row.Rows.slice(indexOfFirstRow, indexOfLastRow);

  useEffect(() => {
    row.setRows(list_data);
  }, [list_data]);

  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th") || [];
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, [visibleColumns]);
    

  console.log("check row is here",list_data);
  const openEditModal = (item, index) => {
    const filterdata = list_data.filter((realitem) => realitem.item_code == item.item_code);
    setfull_Item_Detail(filterdata[0]);
    setCurrentItem({ ...item });
    setCurrentIndex(indexOfFirstRow + index); 
    setShowEditModal(true);
  };

  const handleItemChange = (updatedItem) => {
    setCurrentItem(updatedItem);
  };

  const saveEdit = () => {
    const updatedRows = [...row.Rows];
    updatedRows[currentIndex] = currentItem;
    row.setRows(updatedRows);
    setShowEditModal(false);
  };

const handleInputChange = (index, field, value) => {
  const updatedRows = [...row.Rows];
  const rowIndex = indexOfFirstRow + index;
  const totalQty = parseInt(updatedRows[rowIndex].qty) || 0;
  const newValue = parseInt(value) || 0;

  if (field === "accepted_qty") {
    if (newValue > totalQty) {
      setError(`Accepted quantity cannot be greater than total quantity (${totalQty})`);
      setShowError(true);
      // Reset to max allowed value
      updatedRows[rowIndex][field] = totalQty;
      row.setRows(updatedRows);
      return;
    }
    
    // Also ensure rejected_qty doesn't exceed remaining quantity
    const currentRejected = parseInt(updatedRows[rowIndex].rejected_qty) || 0;
    if (currentRejected > (totalQty - newValue)) {
      updatedRows[rowIndex].rejected_qty = Math.max(0, totalQty - newValue);
    }
  }

  if (field === "rejected_qty") {
    const currentAccepted = parseInt(updatedRows[rowIndex].accepted_qty) || 0;
    if (newValue > (totalQty - currentAccepted)) {
      setError(`Rejected quantity cannot exceed remaining quantity (${totalQty - currentAccepted})`);
      setShowError(true);
      // Reset to max allowed value
      updatedRows[rowIndex][field] = Math.max(0, totalQty - currentAccepted);
      row.setRows(updatedRows);
      return;
    }
  }

  updatedRows[rowIndex][field] = value;
  row.setRows(updatedRows);
};

  const handleSaveColumns = (columns) => {
    setVisibleColumns(columns);
  };

  const renderTableHeader = () => {
    return visibleColumns
      .filter(column => column.selected)
      .map((column, index) => {
        if (column.key === "settings") {
          return (
            <th key={index} onClick={() => setcolumeConfModal(true)} style={{ width: column.width, minWidth: column.width }}>
              <GetIcon iconName="IoSettingsOutline" size={13} />
            </th>
          );
        }
        return <th key={index} style={{ width: column.width, minWidth: column.width }}>
          {column.name}</th>;
      });
  };

  const renderTableRow = (rowData, rowIndex) => {
    const globalIndex = indexOfFirstRow + rowIndex;
    return visibleColumns
      .filter(column => column.selected)
      .map((column, colIndex) => {
        const key = column.key;


        if (key === "sno") {
          return (
            <td key={colIndex} className="p-0" style={{ textAlign: 'center' }}>
              <p className="mb-0" style={{ position: 'relative', top: '3px', height: '29.2px' }}>
                {globalIndex + 1}
              </p>
            </td>
          );
        }
        if (key === "settings") {
          return (
            <td key={colIndex} className="p-0">
              <span onClick={() => openEditModal(rowData, rowIndex)} style={{ position: 'relative', top: '4px' }}>
                <GetIcon iconName="MdOutlineEdit" size={15} />
              </span>
            </td>
          );
        }

        if (["accepted_qty", "rejected_qty"].includes(key)) {
          return (
            <td key={colIndex} className="p-0"  style={{height:'30px'}}>
             <div style={{border: focusedCell.rowIndex === globalIndex && focusedCell.field === key ? '0.3px solid #270b79' : '0px',height:'100%'}}>
               <input
                type={key.includes("date") ? "date" : "text"}
                className="form-control noborder"
                data-rowindex={key === "accepted_qty" && globalIndex}
                data-field={key === "accepted_qty" && "accepted_qty"}
                onFocus={() => {setFocusedCell({ rowIndex: globalIndex, field: key });setFocusedCellkey({ rowIndex:globalIndex, field:key })}}
                 onBlur={() => {setFocusedCell({ rowIndex: null, field: null });setFocusedCellkey({ rowIndex: null, field: null })}}
                style={{ fontSize: '0.8rem',width:key == "accepted_qty" ? '44%' : '',padding:'0 0.75rem',height: "99%",
                  backgroundColor:'transparent',
                  width: "99%",
                  textAlign: "center",
                  position: "relative",
                  left: "0.6px" 
                }}
                value={rowData[key]}
                onChange={(e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      handleInputChange(rowIndex, key, value);
    }
  }}
              />
              </div>
            </td>
          );
        }

         if (key === "expiry_date") {
        return (
          <td key={colIndex} className="p-0" style={{ height: '30px' }}>
            <div style={{ 
              border: focusedCell.rowIndex === globalIndex && focusedCell.field === key ? '0.3px solid #270b79' : '0px',
              height: '100%'
            }}>
              <input
                type="date"
                className="form-control noborder"
                data-rowindex={globalIndex}
                data-field={key}
                onFocus={() => {
                  setFocusedCell({ rowIndex: globalIndex, field: key });
                  setFocusedCellkey({ rowIndex: globalIndex, field: key });
                }}
                onBlur={() => {
                  setFocusedCell({ rowIndex: null, field: null });
                  setFocusedCellkey({ rowIndex: null, field: null });
                }}
                style={{ 
                  fontSize: '0.8rem',
                  padding: '0 0.75rem',
                  height: "99%",
                  backgroundColor: 'transparent',
                  width: "99%",
                  textAlign: "center",
                  position: "relative",
                  left: "0.6px" 
                }}
                value={rowData[key] || ''}
                onChange={(e) => {
                  handleInputChange(rowIndex, key, e.target.value);
                }}
              />
            </div>
          </td>
        );
        }

        return <td key={colIndex} className="p-0" style={{overflow:'hidden'}}>
          <p className="mb-0" style={{ position: 'relative', top: '3px', height: '29.1px',textWrap:'nowrap' }}>
            {key == "amount" || key == "rate" ? `₹${rowData[key]}` : rowData[key] }
          </p>
        </td>;
      });
  };

  return (
    <>
     <style>
        {`
          .resizer {
            position: absolute;
            top: 0;
            right: 0;
            width: 5px;
            height: 100%;
            background: rgba(0, 0, 0, 0.1);
            cursor: col-resize;
            user-select: none;
            touch-action: none;
          }
          
          .resizer:hover,
          .resizer:active {
            background: #ff8d5c;
          }
          
          th {
            position: relative;
          }
          
          .table {
            table-layout: fixed;
            width: 100%;
          }
          
          .tableHead1 th {
            background-color: #f8f9fa;
            font-weight: 600;
          }

          .pagination-container {
            display: flex;
            justify-content: flex-end;
            margin-top: 1rem;
          }
        `}
      </style>
      <table className="table table-bordered" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {renderTableHeader()}
          </tr>
        </thead>
        <tbody>
          {currentRows.map((row, index) => (
            <tr key={index}>{renderTableRow(row, index)}</tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center mt-1 mb-3 centerpagination">
       <div>
          <p style={{ textDecoration: "none" }} className="createbtn m-0">
            <span className="iconbox" style={{ padding: '0px 1px' }}>
              <GetIcon iconName="MdOutlineFileDownload" size={13} />
            </span>
            Download
          </p>
        </div>

       {row.Rows.length > 10 ? <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={rowsPerPage}
          totalrecords={row.Rows.length}
          currentPage={currentPage}
        /> : ''}
        
        {row.Rows.length > 10 ? <div>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79', position: 'relative', top: '-6px' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, row.Rows.length)} of {row.Rows.length} entries
          </span>
        </div> : ''}
        


      </div>

      <ConfigureColumns
        show={columeConfModal}
        onClose={() => setcolumeConfModal(false)}
        onSave={handleSaveColumns}
        initialFields={visibleColumns}
      />

      <EditItemModal
        fulldata={fulldata}
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        full_Item_Detail={full_Item_Detail}
        itemData={currentItem}
        onChange={handleItemChange}
        onSave={saveEdit}
      />

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default Table;